import React from "react";

const TodayBirthdays = ({ birthdays = [] }) => {
  return (
    <div className="card birthday-card">
      {/* HEADER */}
      <div className="card-header birthday-snow-header">
        {/* <span className="birthday-title-text">🎂Today Birthdays List🎊</span> */}
<h5 className="card-title mb-0">
       🎂Today's Birthday List🎊
        </h5>
        <span className="snowflake">❄</span>
        <span className="snowflake">❅</span>
        <span className="snowflake">❆</span>

        <span className="birthday-pop pop-1">🎈</span>
        <span className="birthday-pop pop-2">🎉</span>
        <span className="birthday-pop pop-3">🎊</span>
      </div>

      {/* 👇 MANUAL SCROLL BODY */}
      <div className="card-body birthday-scroll-manual">
        {birthdays.length === 0 ? (
          <div className="no-birthday">No birthdays today 🎈</div>
        ) : (
          birthdays.map((emp, index) => (
            <div className="birthday-row" key={index}>
              <div className="birthday-avatar">
                {emp.employee_name
                  .split(" ")
                  .map(n => n[0])
                  .join("")
                  .slice(0, )
                  .toUpperCase()}
              </div>

              <div>
                <div className="birthday-name">{emp.employee_name}</div>
                <div className="birthday-date">{emp.department}</div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default TodayBirthdays;
